<template>
  <v-container
    :class="{ 'px-5 py-2': xsOnly, 'min-width-available mr-12': mdOnly, 'max-width-700': smOnly  }">
    <v-layout :column="smAndDown" :class="{ 'mt-25': mdAndUp, 'mt-10': smOnly }">
      <!-- KEEP SHOPPING (BIG) -->
      <v-flex v-if="mdAndUp" xs4>
        <v-layout column justify-center align-center class="mx-10 full-height" :class="{ 'ml-0' : mdOnly }">
          <v-layout column class="flex-none">
            <span class="keep-shopping">{{ $t('summary.keep_shopping') }}</span>
            <v-layout class="flex-none" justify-center>
              <img
                src="@/assets/zepelin.png"
                class="zepelin left-zepelin my-10"
                @click="$router.go(-1)">
            </v-layout>
          </v-layout>
          <v-layout justify-center class="flex-none">
            <v-icon size="35" color="accent" @click="$router.go(-1)">mdi-arrow-left</v-icon>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-flex v-if="mdAndUp" xs1>
        <v-divider vertical class="my-4 mr-10"/>
      </v-flex>
      <!-- PRODUCT LIST -->
      <v-flex :xs7="mdAndUp">
        <v-layout column>
          <template v-if="xsOnly">
            <v-layout justify-end class="mt-5">
              <order-summary />
            </v-layout>
          </template>
          <subtitle :text="$t('order.my_order')" :class="{ 'mt-3': smAndDown, 'mb-3': mdAndUp }" />
          <v-layout column v-if="cart.cartProducts.length">
            <div v-for="(p, i) in cart.cartProducts" :key="i" class="mt-3" :class="mdAndUp ? 'mt-6' : ''">
              <v-layout align-start>
                <v-icon
                  v-if="mdAndUp"
                  @click="$store.commit('cart/removeProductInCart', p.product)"
                  color="accent"
                  class="remove-icon mr-5"
                  size="35">close</v-icon>
                <v-flex>
                  <v-layout justify-space-between align-start>
                    <span class="package-name break-word" :class="{ 'mr-10': mdAndUp, 'mr-3': xsOnly }">{{ p.product.name }}</span>
                    <v-icon
                      v-if="smAndDown"
                      @click="$store.commit('cart/removeProductInCart', p.product)"
                      color="accent"
                      class="remove-icon"
                      size="35">close</v-icon>
                  </v-layout>
                  <v-layout class="mt-3" :class="mdAndUp ? 'mb-3' : ''">
                    <v-layout wrap>
                      <v-layout column class="mr-3">
                        <span class="field-title">{{ smAndUp ? $t('fields.quantity') : $t('summary.qty') }}</span>
                        <span class="field-amount">{{ p.quantity }}</span>
                      </v-layout>
                      <v-layout column class="mr-3">
                        <span class="field-title">{{ $t('summary.package_price') }}</span>
                        <span class="field-amount">{{ getPriceStr({ cartProduct: p }) }}</span>
                      </v-layout>
                    </v-layout>
                    <v-layout column align-end class="ml-3">
                      <span class="field-title">{{ $t('summary.subtotal') }}</span>
                      <span class="field-amount total-amount-field">{{ getPriceStr({ cartProduct: p, getTotal: true }) }}</span>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider />
            </div>
          </v-layout>
          <template v-else-if="!cart.cartProducts.length">
            <v-spacer />
            <v-layout
              justify-center
              align-center
              class="no-products mt-10">
              {{ $t('summary.no_products') }}
            </v-layout>
          </template>
          <v-spacer />
          <v-layout column align-end class="flex-none" :class="{ 'mt-20 mx-2': smAndDown, 'mt-5': mdAndUp }">
            <span class="total-title">{{ $t('summary.total') }}</span>
            <span class="total-amount">{{ totalStr }}</span>
            <main-button
              :class="mdAndUp ? 'mt-10' : 'mt-6'"
              :text="smAndUp ? $t('summary.confirm_payment') : $t('summary.confirm')"
              :medium="xsOnly"
              :disabled="!cart.cartProducts.length || isBookingDisabled"
              @click="postOrder()"
              :loading="loadingPost" />
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- KEEP SHOPPING (SMALL) -->
      <v-layout v-if="smAndDown" column justify-center class="mt-10">
        <subtitle :text="$t('summary.or')" class="mb-3" />
        <v-layout column>
          <v-layout :class="smAndUp ? 'mb-3' : ''">
            <v-spacer v-if="smOnly" />
            <v-icon :size="smOnly ? 70 : 35" color="accent" @click="$router.go(-1)">mdi-arrow-left</v-icon>
            <v-spacer />
            <img src="@/assets/zepelin.png"
              class="zepelin bottom-zepelin mx-10"
              @click="$router.go(-1)">
            <v-spacer />
          </v-layout>
          <span class="keep-shopping">{{ $t('summary.keep_shopping') }}</span>
        </v-layout>
        <v-layout justify-center v-if="mdAndUp" :class="{'flex-none': mdAndUp }">
          <v-icon size="35" color="accent" @click="$router.go(-1)">mdi-arrow-left</v-icon>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moneyFormatMixins from '@/mixins/MoneyFormat'
import vuetifyMixins from '@/mixins/Vuetify'
import routeNames from '@/router/routes'

export default {
  data () {
    return {
      loadingPost: false
    }
  },
  computed: {
    ...mapState(['cart', 'me', 'state']),
    ...mapGetters({
      exchangeCurrencies: 'me/configCurrencies',
      defaultCurrency: 'me/defaultCurrency',
      getApplicablePrice: 'guests/getApplicablePrice',
      localCurrencyId: 'me/localCurrencyId',
      total: 'cart/total',
      isBookingDisabled: 'bookings/isBookingDisabled'
    }),
    selectedCurrency: {
      get () {
        return this.cart.selectedCurrency
      },
      set (currency) {
        this.$store.commit('cart/setSelectedCurrency', currency)
      }
    },
    exchangeRate () {
      return this.selectedCurrency.exchangeRate
    },
    currencyName () {
      return this.selectedCurrency.currency.name
    },
    totalStr () {
      return `${this.formatAmount(this.total / this.exchangeRate)} ${this.currencyName}`
    }
  },
  methods: {
    getPriceStr ({ cartProduct, getTotal }) {
      const price = this.getApplicablePrice(cartProduct.product.pricingGroupWithPrices) * (getTotal ? cartProduct.quantity : 1) / this.exchangeRate
      return `${this.formatAmount(price)} ${this.currencyName}`
    },
    postOrder () {
      this.loadingPost = true
      this.$store.dispatch('packages/postOrder').then(() => {
        this.$router.push({ name: routeNames.paymentFrame.name })
      }).catch(() => {
        this.loadingPost = false
      })
    }
  },
  created () {
    this.$store.commit('cart/recoverCart')
    this.$store.dispatch('guests/get', { id: this.cart.selectedGuest, save: true })
    if (!this.selectedCurrency) {
      this.$store.dispatch('me/getConfig', { save: true })
      this.selectedCurrency = this.defaultCurrency
    }
  },
  components: {
    OrderSummary: () => import('@/components/view-components/OrderSummary.vue'),
    Subtitle: () => import('@/components/view-components/Subtitle.vue'),
    MainButton: () => import('@/components/app-components/MainButton.vue')
  },
  mixins: [moneyFormatMixins, vuetifyMixins]
}
</script>

<style lang="scss" scoped>
.max-width-300 {
  max-width: 300px !important;
}
.remove-icon {
  size: 30px;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
  cursor: pointer;
}
.field-title {
  text-transform: uppercase;
  font-size: 13px;
  color: #69615F;
}
.field-amount {
  font-size: 18px;
  margin-bottom: 12px;
}
.total-field-amount {
  text-align: end;
}
.zepelin {
  width: fit-content;
  height: auto;
  cursor: pointer;
  transform: scaleX(-1);
}
.bottom-zepelin {
  width: -webkit-fill-available;
  @media (min-width: 961px) {
    max-width: 400px !important;
  }
  @media (max-width: 960px) {
    max-width: 150px !important;
  }
}
.left-zepelin {
  max-width: 100%;
}

.keep-shopping {
  font-weight: 1000;
  text-align: center;
  color: #E05A00;
  font-size: 35px;
  line-height: normal;
  @media (min-width: 601px) and (max-width: 960px) {
    font-size: 58px;
  }
  @media (min-width: 960px) and (max-width: 1263px) {
    font-size: 50px;
  }
  @media (min-width: 1264px) {
    font-size: 58px;
  }
}
.package-name {
  font-size: 23px;
  color: #392F2C;
  font-weight: 800;
  @media (min-width: 960px) {
    font-size: 30px;
  }
}
.total-title {
  font-size: 18px;
  color: #392F2C;
  text-transform: uppercase;
  font-weight: 600;
  line-height: normal;
}
.total-amount {
  font-size: 30px;
  color: #E05A00;
  font-weight: 1000;
  line-height: normal;
}
.no-products {
  color: lightgray;
  @media (max-width: 600px) {
    font-size: 40px;
    line-height: 40px;
  }
  @media (min-width: 601px) {
    font-size: 58px;
    line-height: 58px;
  }
}
</style>
